<div class="mod_formaem">
	<div class="progressbar-wrapper">
		<div class="mod_formaemprogressbar">
			<div class="progressbar">
				<div class="progress-object" [ngClass]="{'currentStep' : steps == 1}">
					<span class="numberBlock">1</span>
					<span class="labelBlock">Unternehmen</span>
				</div>
				<div class="progress-object" [ngClass]="{'currentStep' : steps == 2}">
					<span class="numberBlock">2</span>
					<span class="labelBlock">Dokumente</span>
				</div>
				<div class="progress-object" [ngClass]="{'currentStep' : steps == 3}">
					<span class="numberBlock">3</span>
					<span class="labelBlock">Abschluss</span>
				</div>
				<div class="progress-object" [ngClass]="{'currentStep' : steps == 4}">
					<span class="numberBlock">4</span>
					<span class="labelBlock">Bestätigung</span>
				</div>
			</div>

		</div>

	</div>
	<div class="form-wrapper">

		<form [formGroup]="form">

			@if (steps == 1) {
				<ng-container formGroupName="unternehmen">
					<div class="border-bottom">
						<div>
							<label>Überprüfen Sie die Angaben zu dem Unternehmen und Ansprechpartner auf ihre Aktualität
								und
								korrigieren Sie diese falls notwendig.</label>
						</div>
						<h2 class="dah-heading">Unternehmen</h2>
						<div class="layout_column">
							<app-input [form]="getUnternehmenForm()"
									   [submitted]="unternehmenSubmnitted"
									   name="name"
									   label="Unternehmen *"
									   [readonly]="readonly"></app-input>
							@if (tenant.content.angebot.unternehmenInfoText) {
								<span class="input_hint">{{tenant.content.angebot.unternehmenInfoText}}</span>
							}
						</div>
						<div class="layout_column">
							<app-input [form]="getUnternehmenForm()" [submitted]="unternehmenSubmnitted"
									   name="adresse"
									   label="Strasse und Nr. *"
									   [readonly]="readonly" [attr.disabled]="readonly ? '' : null"></app-input>
						</div>
						<div class="layout_column">
							<app-input [form]="getUnternehmenForm()"
									   name="plz"
									   label="PLZ *"
									   [submitted]="unternehmenSubmnitted"
									   [readonly]="readonly"
									   [attr.disabled]="readonly ? '' : null"></app-input>
						</div>
						<div class="layout_column">
							<app-input [form]="getUnternehmenForm()"
									   name="ort"
									   label="Ort *"
									   [submitted]="unternehmenSubmnitted"
									   [readonly]="readonly"></app-input>
						</div>
						<div class="layout_column">
							<app-input [form]="getUnternehmenForm()"
									   name="uid" [submitted]="unternehmenSubmnitted"
									   label="Unternehmens-Identifikationsnummer UID"
									   [readonly]="readonly"></app-input>
						</div>
						<div class="layout_column">
							<app-input [form]="getUnternehmenForm()"
									   name="mwstNummer" [submitted]="unternehmenSubmnitted"
									   label="MwSt.-Nummer"
									   [readonly]="readonly"></app-input>
						</div>
						<div class="mod_formcheckbox" data-init="formcheckbox">
							<input formControlName="arge" type="checkbox"
								   [readOnly]="readonly" [attr.disabled]="readonly ? '' : null"
								   id="arbeitsgemeinschaft"
								   name="arbeitsgemeinschaft" (change)="argeValueChanged()"/>
							<label for="arbeitsgemeinschaft">Wir sind eine Arbeitsgemeinschaft (ARGE) </label>
						</div>
						@if (getUnternehmenForm().get('arge')?.value) {
							<div class="margin-top-40">
								<label>Bitte geben Sie den Namen der Arbeitsgemeinschaft (ARGE) an</label>
							</div>
							<div class="form-group" class="mod_formtextinput not_empty"
								 [ngClass]="{'error' : formControlHasError(toFormControl(getUnternehmenForm().get('argeName')))}">
								<input formControlName="argeName" type="text"
									   name="argeName"
									   [readOnly]="readonly"
									   [attr.disabled]="readonly ? '' : null"
									   id="argeName"
									   class="flying-focus_target">
								<label for="argeName">Name der Arbeitsgemeinschaft (ARGE) *</label>
							</div>
							<div class="margin-top-40">
								<label>Bitte geben Sie die weiteren Unternehmen der ARGE an</label>
							</div>
							@for (s of getArges().controls; track s; let i = $index) {
								<ng-container formArrayName="arges"
								>
									<ng-container [formGroupName]="i">
										<div class="form-group" class="mod_formtextinput not_empty"
											 [ngClass]="{'error' : formControlHasError(toFormControl(s.get('name')))}">
											<input formControlName="name" type="text"
												   name="nameArge"
												   [readOnly]="readonly"
												   [attr.disabled]="readonly ? '' : null"
												   id="nameArge"
												   class="flying-focus_target">
											<label for="nameArge">Unternehmen *</label>
										</div>
										<app-input-error [submitted]="unternehmenSubmnitted"
														 [control]="toFormControl(s.get('name'))"></app-input-error>
										<div class="mod_formtextinput not_empty"
											 [ngClass]="{'error' : formControlHasError(toFormControl(s.get('bkpLeistung')))}">
											<input formControlName="bkpLeistung" type="text"
												   name="bkpLeistungArge"
												   [readOnly]="readonly"
												   [attr.disabled]="readonly ? '' : null"
												   id="bkpLeistungArge"
												   class="flying-focus_target">
											<label for="bkpLeistungArge">{{ leistungLabel }}</label>
										</div>
										<app-input-error [submitted]="unternehmenSubmnitted"
														 [control]="toFormControl(s.get('bkpLeistung'))"></app-input-error>
										<div class="mod_formtextinput not_empty"
											 [ngClass]="{'error' : formControlHasError(toFormControl(s.get('plz')))}">
											<input formControlName="plz" type="text"
												   name="plzArge"
												   [readOnly]="readonly"
												   [attr.disabled]="readonly ? '' : null"
												   id="plzArge"
												   class="flying-focus_target">
											<label for="plzArge">PLZ *</label>
										</div>
										<app-input-error [submitted]="unternehmenSubmnitted"
														 [control]="toFormControl(s.get('plz'))"></app-input-error>
										<div class="mod_formtextinput not_empty"
											 [ngClass]="{'error' : formControlHasError(toFormControl(s.get('plz')))}">
											<input formControlName="ort" type="text"
												   name="ortArge"
												   [readOnly]="readonly"
												   [attr.disabled]="readonly ? '' : null"
												   id="ortArge"
												   class="flying-focus_target">
											<label for="ortArge">Ort *</label>
										</div>
										<app-input-error [submitted]="unternehmenSubmnitted"
														 [control]="toFormControl(s.get('ort'))"></app-input-error>
										<div>
											<input (click)="onDeleteArges(i)"
												   type="button"
												   [disabled]="readonly"
												   [attr.disabled]="readonly ? '' : null"
												   class="mod_button var_secondary margin-bottom-40"
												   value="Eintrag löschen">
										</div>
									</ng-container>
								</ng-container>
							}
							<div>
								<input (click)="onAddArges()"
									   type="button"
									   [disabled]="readonly"
									   [attr.disabled]="readonly ? '' : null"
									   class="mod_button var_secondary"
									   value="Weiteren Eintrag hinzufügen"/>
							</div>
						}
						<div class="mod_formcheckbox" data-init="formcheckbox">
							<input formControlName="subs"
								   [readOnly]="readonly" [attr.disabled]="readonly ? '' : null"
								   id="subUnternehmenCheckbox"
								   type="checkbox"
								   name="subUnternehmenCheckBox" (change)="subUnternehmenChange()"/>
							<label for="subUnternehmenCheckbox">Wir ziehen Subunternehmen bei</label>
						</div>
						@if (hasSubunternehmen()) {
							<div class="margin-top-40">
								<label>Bitte geben Sie die einzelnen Subunternehmen an</label>
							</div>
							@for (s of getSubUnternehmen().controls; track s; let i = $index) {
								<ng-container formArrayName="subunternehmen"
								>
									<ng-container [formGroupName]="i">
										<div class="form-group" class="mod_formtextinput not_empty"
											 [ngClass]="{'error' : formControlHasError(toFormControl(s.get('name')))}">
											<input formControlName="name" type="text"
												   name="namesu"
												   [readOnly]="readonly"
												   [attr.disabled]="readonly ? '' : null"
												   id="namesu"
												   class="flying-focus_target">
											<label for="namesu">Unternehmen *</label>
										</div>
										<app-input-error [submitted]="unternehmenSubmnitted"
														 [control]="toFormControl(s.get('name'))"></app-input-error>
										<div class="mod_formtextinput not_empty"
											 [ngClass]="{'error' : formControlHasError(toFormControl(s.get('bkpLeistung')))}">
											<input formControlName="bkpLeistung" type="text"
												   name="bkpLeistung"
												   [readOnly]="readonly"
												   [attr.disabled]="readonly ? '' : null"
												   id="bkpLeistung"
												   class="flying-focus_target">
											<label for="bkpLeistung">{{ leistungLabel }}</label>
										</div>
										<app-input-error [submitted]="unternehmenSubmnitted"
														 [control]="toFormControl(s.get('bkpLeistung'))"></app-input-error>
										<div class="mod_formtextinput not_empty"
											 [ngClass]="{'error' : formControlHasError(toFormControl(s.get('plz')))}">
											<input formControlName="plz" type="text"
												   name="plzSubunternehmen"
												   [readOnly]="readonly"
												   [attr.disabled]="readonly ? '' : null"
												   id="plzSubunternehmen"
												   class="flying-focus_target">
											<label for="plzSubunternehmen">PLZ *</label>
										</div>
										<app-input-error [submitted]="unternehmenSubmnitted"
														 [control]="toFormControl(s.get('plz'))"></app-input-error>
										<div class="mod_formtextinput not_empty"
											 [ngClass]="{'error' : formControlHasError(toFormControl(s.get('plz')))}">
											<input formControlName="ort" type="text"
												   name="ortSubunternehmen"
												   [readOnly]="readonly"
												   [attr.disabled]="readonly ? '' : null"
												   id="ortSubunternehmen"
												   class="flying-focus_target">
											<label for="ortSubunternehmen">Ort *</label>
										</div>
										<app-input-error [submitted]="unternehmenSubmnitted"
														 [control]="toFormControl(s.get('ort'))"></app-input-error>
										<div>
											<input (click)="onDeleteSubunternehmen(i)"
												   type="button"
												   [disabled]="readonly"
												   [attr.disabled]="readonly ? '' : null"
												   class="mod_button var_secondary margin-bottom-40"
												   value="Eintrag löschen">
										</div>
									</ng-container>
								</ng-container>
							}
							<div>
								<input (click)="onAddSubunternehmen()"
									   type="button"
									   [disabled]="readonly"
									   [attr.disabled]="readonly ? '' : null"
									   class="mod_button var_secondary"
									   value="Weiteren Eintrag hinzufügen"/>
							</div>
						}
						<h2 class="dah-heading">Ansprechpartner</h2>
						<div class="form_section">
							<div class="mod_formradio var_horizontal">
								<input type="radio"
									   id="herr"
									   name="kontaktpersonAnrede"
									   formControlName="kontaktpersonAnrede"
									   value="Herr">
								<label for="herr">Herr</label>
							</div>
							<div class="mod_formradio var_horizontal">
								<input type="radio"
									   id="frau"
									   name="kontaktpersonAnrede"
									   formControlName="kontaktpersonAnrede"
									   value="Frau">
								<label for="frau">Frau</label>
							</div>
						</div>
						<div class="layout_column">
							<app-input [form]="getUnternehmenForm()" [submitted]="unternehmenSubmnitted"
									   name="kontaktperson"
									   label="Nachname *"
									   [readonly]="readonly"></app-input>
						</div>
						<div class="layout_column">
							<app-input [form]="getUnternehmenForm()" [submitted]="unternehmenSubmnitted"
									   name="kontaktpersonVorname"
									   label="Vorname *"
									   [readonly]="readonly"></app-input>
						</div>
						<div class="layout_column">
							<app-input [form]="getUnternehmenForm()" [submitted]="unternehmenSubmnitted"
									   name="tel"
									   label="Telefon *"
									   [readonly]="readonly"></app-input>
						</div>
						<div class="layout_column">
							<div class="flex-container">
								<div class="flex-input">
									<app-input [form]="getUnternehmenForm()" [submitted]="unternehmenSubmnitted"
											   name="email"
											   label="E-Mail *"
											   [readonly]="true"></app-input>
								</div>
								<div class="flex-edit">
									<a [href]="tenant.content.angebot.meinKontoSettingsUrl"
									   title="Angaben bearbeiten"
									   class="icon_ico_pencil"></a>
								</div>
							</div>
						</div>
					</div>
					<div class="navigation-buttons">
						<div>
							@if (!readonly) {
								<input
										type="button"
										class="mod_button var_secondary"
										(click)="cancel()"
										value="Abbrechen">
							}
						</div>
						<div>
							<input type="button"
								   (click)="switch(2)"
								   class="mod_button"
								   [value]="getNextLabel()">
						</div>
					</div>
				</ng-container>
			}
			@if (steps == 2) {
				<ng-container formGroupName="angebot">
					<div class="signature-info">
						<h2 class="dah-heading">Elektronische Signatur der Dokumente <span (click)="showInfo()"
															   class="icon_ico_question"></span></h2>
						<div class="form_section"
							 [class]="getFormControl('qualifiedSignature').errors?.['required'] ? 'error' : ''">
							<div class="mod_formradio">
								<input type="radio"
									   id="qualifiedSignatureTrue"
									   name="qualifiedSignature"
									   formControlName="qualifiedSignature"
									   [value]="true">
								<label for="qualifiedSignatureTrue">
									Ich habe eine <strong>qualifizierte elektronische Signatur</strong> nach
									schweizerischem Recht, mit
									welcher ich alle zu unterzeichnenden Dokumente vor dem Hochladen digital signiert
									habe.
								</label>
							</div>
							<div class="mod_formradio">
								<input type="radio"
									   id="qualifiedSignatureFalse"
									   name="qualifiedSignature"
									   formControlName="qualifiedSignature"
									   [value]="false">
								<label for="qualifiedSignatureFalse">
									Ich möchte bei der Übermittlung eine <strong>schriftliche Angebotsbestätigung
									(Beiblatt)</strong>
									generieren, welche ich ausdrucken, handschriftlich unterzeichnen und in Papierform
									einreichen kann.
									Die handschriftliche Unterzeichnung des Beiblatts gilt als Unterzeichnung für alle
									einzureichenden Unterlagen.
								</label>
							</div>
						</div>
						@if (getFormControl('qualifiedSignature').invalid && (getFormControl('qualifiedSignature').dirty || getFormControl(
                                'qualifiedSignature').pristine)) {
							<div class="alert">
								@if (getFormControl('qualifiedSignature').errors?.['required']) {
									<div class="error_msg">
										Bitte treffen Sie eine Auswahl.
									</div>
								}
							</div>
						}
					</div>
					@if (!isSelektivesVerfahren) {
						<div class="border-bottom">
							<h2 class="dah-heading">Angebot</h2>
							<div>
                <p>{{tenant.content.angebot.uploadInstruction}}</p>
              </div>
							<div class="layout_column">
								@let angebotKey = getAngebotDocumentIdentifier();
								<app-input-upload label="Angebot"
												  [key]="angebotKey"
												  [readonly]="readonly"
												  [control]="getFormControl('angebotDocument')"
												  [submitted]="angebotSubmnitted"
												  [form]="getAngebotForm()"
												  [validateSignature]="isQualifiedSignature() && tenant.features.signatureValidation"
												  [supportedFiles]="[{
													'fileExtension': 'pdf', 'mimeTypes': ['application/pdf'],
													checkExtOnly: false
												}]">
								</app-input-upload>
							</div>
							<div class="parsys">
								<div class="parsys_column two_cols flex-center">
									<div class="parsys_column two_cols-c0">
										<label>Eingabe netto inkl. MwSt. *</label>
									</div>
									<div class="parsys_column two_cols-c1">
										<app-input [form]="getAngebotForm()" [submitted]="angebotSubmnitted"
												   [isCurrency]="true"
												   name="preisNettoInklMwstOfferte"
												   [readonly]="readonly"></app-input>
									</div>
								</div>
								<div class="parsys_column two_cols flex-center">
									<div class="parsys_column two_cols-c0">
										<label>Rabatt %</label>
									</div>
									<div class="parsys_column two_cols-c1">
										<app-input [form]="getAngebotForm()" [submitted]="angebotSubmnitted"
												   name="rabatt"
												   [isPercentage]=true
												   [readonly]="readonly"></app-input>
									</div>
								</div>
								@if (tenant.features.skonto) {
									<div class="parsys_column two_cols flex-center">
										<div class="parsys_column two_cols-c0">
											<label>Skonto %</label>
										</div>
										<div class="parsys_column two_cols-c1">
											<app-input [form]="getAngebotForm()" [submitted]="angebotSubmnitted"
													   name="skonto"
													   [isPercentage]=true
													   [readonly]="readonly"></app-input>
										</div>
									</div>
								}
							</div>
						</div>
					}
					@if (varianteSelected() && !isSelektivesVerfahren) {
						<div class="border-bottom">
							<div class="mod_formcheckbox">
								<input formControlName="finanzielleVariante" type="checkbox"
									   id="variante"
									   name="variante" (change)="varianteChanged()"/>
								<label for="variante">{{ getVarianteText() }}</label>
							</div>
							@if (getAngebotForm().get('finanzielleVariante')?.value) {
								<h2 class="dah-heading">{{ getVarianteHeading() }}</h2>
								<div class="layout_column">
									<div class="parsys">
										<div class="parsys_column two_cols flex-center">
											<div class="parsys_column two_cols-c0">
												<label>Angebot {{ getVarianteAngebotLabel() }} netto inkl. MwSt.
													*</label>
											</div>
											<div class="parsys_column two_cols-c1">
												<app-input [form]="getAngebotForm()" [submitted]="angebotSubmnitted"
														   name="pauschalNettoInklMwst"
														   [isCurrency]="true" [readonly]="readonly"></app-input>
											</div>
										</div>
									</div>
								</div>
								@if (tenant.features.varianteUpload && getVarianteAngebotKey(); as varianteKey) {
									<div class="layout_column">
										<app-input-upload label="Angebot Variante"
														  [key]="varianteKey"
														  [readonly]="readonly"
														  [control]="getFormControl(varianteKey)"
														  [submitted]="angebotSubmnitted"
														  [form]="getAngebotForm()"
														  [supportedFiles]="[{
															'fileExtension': 'pdf', 'mimeTypes': ['application/pdf'],
															checkExtOnly: false
														}]">
										</app-input-upload>
									</div>
								}
							}
						</div>
					}
					@if (hasLose) {
						<div class="border-bottom">
							<h2 class="dah-heading">Lose</h2>
							<p>Wählen Sie die Lose aus, für die Sie ein Angebot einreichen möchten.</p>
							@for (def of losDefinitions; track def.id) {
								<div class="mod_formcheckbox">
									<input type="checkbox"
										   [id]="'los_' + def.id"
										   [checked]="isLosSelected(def.id)"
										   [disabled]="readonly"
										   (change)="toggleLos(def)"/>
									<label [for]="'los_' + def.id">Los {{ def.nummer }}: {{ def.bezeichnung }}</label>
								</div>
								@if (getLosGroup(def.id); as group) {
									@let losId = group.get('losId')?.value;
									<div class="los-set margin-bottom-40">
										@if (losId) {
											<div class="layout_column">
												<app-input-upload label="Angebot"
																  [key]="getLosAngebotKey(losId)"
																  [readonly]="readonly"
																  [control]="getFormControl(getLosAngebotKey(losId))"
																  [submitted]="angebotSubmnitted"
																  [form]="getAngebotForm()"
																  [supportedFiles]="[{
																	'fileExtension': 'pdf', 'mimeTypes': ['application/pdf'],
																	checkExtOnly: false
																}]">
												</app-input-upload>
											</div>
										}
										<div class="parsys">
											<div class="parsys_column two_cols flex-center">
												<div class="parsys_column two_cols-c0">
													<label>Eingabe brutto exkl. MWST *</label>
												</div>
												<div class="parsys_column two_cols-c1">
													<app-input [form]="group" [submitted]="angebotSubmnitted"
															   name="preisBruttoExklMwst"
															   [isCurrency]="true" [readonly]="readonly"></app-input>
												</div>
											</div>
											<div class="parsys_column two_cols flex-center">
												<div class="parsys_column two_cols-c0">
													<label>Rabatt %</label>
												</div>
												<div class="parsys_column two_cols-c1">
													<app-input [form]="group" [submitted]="angebotSubmnitted"
															   name="rabatt"
															   [isPercentage]="true" [readonly]="readonly"></app-input>
												</div>
											</div>
										</div>
										@if (losId) {
											@for (sd of loseDocuments(); track sd.id) {
												<p class="margin-bottom-5"><strong>{{ sd.title }}</strong></p>
												<p>{{ sd.description }}</p>
												@if (!sd.alleAnbieter) {
													@for (variant of sd.variants; track variant.id) {
														@let losDocKey = getLosDocKey(losId, sd.id, 'HAUPT', variant.id);
														<div class="layout_column">
															<app-input-upload [label]="getLabel(variant)"
																			  [key]="losDocKey"
																			  [readonly]="readonly"
																			  [control]="variant.required ? getFormControl(losDocKey) : null"
																			  [submitted]="angebotSubmnitted"
																			  [form]="getAngebotForm()"
																			  [supportedFiles]="variant.supportedFiles"
																			  [validateSignature]="hasValidateSignature(sd)"
															></app-input-upload>
														</div>
													}
												}
												@if (sd.alleAnbieter) {
													@for (anbieter of alleAnbieter; track anbieter) {
														<p class="margin-bottom-5">{{ unescapeWhitelistetChars(anbieter.name) }}</p>
														@for (variant of sd.variants; track variant.id) {
															@let losDocKey = getLosDocKey(losId, sd.id, anbieter.docIdentifier, variant.id);
															<div class="layout_column">
																<app-input-upload [label]="getLabel(variant)"
																				  [key]="losDocKey"
																				  [readonly]="readonly"
																				  [control]="variant.required ? getFormControl(losDocKey) : null"
																				  [submitted]="angebotSubmnitted"
																				  [form]="getAngebotForm()"
																				  [supportedFiles]="variant.supportedFiles"
																				  [validateSignature]="hasValidateSignature(sd)"
															></app-input-upload>
														</div>
													}
												}
											}
										}
										}
									</div>
								}
							}
						</div>
					}
					@for (sd of ausschreibungDocuments(); track sd; let i = $index) {
						<h2 class="dah-heading">{{ sd.title }}</h2>
						<p>{{ sd.description }}</p>
						@if (!sd.alleAnbieter) {
							<div class="border-bottom">
								@for (variant of sd.variants; track variant; let j = $index) {
									@let docKey = id+'_'+supplierId+'_DEFINITION_'+sd.id +'_'+ 'HAUPT' + '_'+ variant.id;
									<div class="layout_column">
										<app-input-upload [label]="getLabel(variant)"
														  [key]="docKey"
														  [readonly]="readonly"
														  [control]="variant.required ? getFormControl(docKey) : null"
														  [submitted]="angebotSubmnitted"
														  [formGroup]="getAngebotForm()"
														  [supportedFiles]="variant.supportedFiles"
														  [validateSignature]="hasValidateSignature(sd)"
											></app-input-upload>
									</div>
								}
							</div>
						}
						@if (sd.alleAnbieter) {
							<div class="border-bottom">
								@for (anbieter of alleAnbieter; track anbieter; let x = $index) {
									<p class="margin-bottom-5">{{ unescapeWhitelistetChars(anbieter.name) }}</p>
									@for (variant of sd.variants; track variant; let y = $index) {
										@let docKey = id+'_'+supplierId+'_DEFINITION_'+sd.id +'_'+ anbieter.docIdentifier +'_'+ variant.id;
										<div class="layout_column">
											<app-input-upload [label]="getLabel(variant)"
															  [key]="docKey"
															  [readonly]="readonly"
															  [control]="variant.required ? getFormControl(docKey) : null"
															  [submitted]="angebotSubmnitted"
															  [formGroup]="getAngebotForm()"
															  [supportedFiles]="variant.supportedFiles"
 														  [validateSignature]="hasValidateSignature(sd)"
											></app-input-upload>
										</div>
									}
								}
							</div>
						}
					}
					<ng-container>
						<h2 class="dah-heading">Weitere Dokumente</h2>
						<div>
							<p>Es können bis zu drei weitere Dokumente hochgeladen werden.</p>
						</div>
						<div class="layout_column">
							@for (addDoc of additional; track addDoc; let i = $index) {
								<app-input [form]="getAngebotForm()"
										   [submitted]="angebotSubmnitted"
										   [name]="getAdditionalName(addDoc)"
										   label="Name des Dokuments *"
										   [readonly]="readonly"></app-input>
								<app-input-upload label="Dokument"
												  [key]="getAdditionalIdentifier(addDoc)"
												  [readonly]="readonly"
												  [formGroup]="getAngebotForm()"
												  [supportedFiles]="[
                                    {'fileExtension': 'pdf' , 'mimeTypes': ['application/pdf'], 'checkExtOnly': false},
                                    {'fileExtension': 'doc' , 'mimeTypes': ['application/msword'], 'checkExtOnly': false},
                                    {'fileExtension': 'docx', 'mimeTypes': ['application/msword'], 'checkExtOnly': false},
                                    {'fileExtension': 'rtf' , 'mimeTypes': ['application/rtf'], 'checkExtOnly': false},
                                    {'fileExtension': 'xlsx', 'mimeTypes': ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'], 'checkExtOnly': false},
                                    {'fileExtension': 'xls' , 'mimeTypes': ['application/vnd.ms-excel'], 'checkExtOnly': false},
                                    {'fileExtension': 'png' , 'mimeTypes': ['image/png'], 'checkExtOnly': false},
                                    {'fileExtension': 'jpg' , 'mimeTypes': ['image/jpeg'], 'checkExtOnly': false},
                                    {'fileExtension': 'jpeg', 'mimeTypes': ['image/jpeg'], 'checkExtOnly': false},
                                    {'fileExtension': 'ppt' , 'mimeTypes': ['application/vnd.ms-powerpoint'], 'checkExtOnly': false},
                                    {'fileExtension': 'pptx', 'mimeTypes': ['application/vnd.openxmlformats-officedocument.presentationml.presentation'], 'checkExtOnly': false},
                                    {'fileExtension': 'crbx', 'mimeTypes': [''], 'checkExtOnly': false},
                                 ]"></app-input-upload>
								<div>
									@if ((additional.length - 1) === i) {
										<input (click)="removeAdditional()"
											   type="button"
											   [disabled]="readonly"
											   [attr.disabled]="readonly ? '' : null"
											   class="mod_button var_secondary margin-bottom-40"
											   value="Eintrag löschen"/>
									}
								</div>
							}
							<div>
								<input (click)="addAdditional()"
									   type="button"
									   [disabled]="readonly || this.additional.length >= 3"
									   [attr.disabled]="(readonly || this.additional.length >= 3) ? '' : null"
									   class="mod_button var_secondary"
									   value="Weiteres Dokument hinzufügen"/>
							</div>
						</div>
					</ng-container>
					<div class="navigation-buttons">
						<div>
							<input type="button"
								   (click)="switchBack(1)"
								   class="mod_button var_secondary"
								   value="Zurück">
						</div>
						<div>
							<input type="button" (click)="cancel()" class="mod_button var_secondary" value="Abbrechen">
						</div>
						<div>
							<input type="button" (click)="switch(3)"
								   class="mod_button"
								   [value]="getNextLabel()">
						</div>
					</div>
				</ng-container>
			}
			@if (steps == 3) {
				<ng-container formGroupName="requirements">
					<h2 class="dah-heading">Rechtliches</h2>
					<p class="margin-bottom-40">Sie haben sich entschieden an der Ausschreibung teilzunehmen. Bitte
						lesen Sie sich
						die untenstehenden Bedingungen durch und akzeptieren Sie diese.</p>
					@for (r of requirementos; track r; let i = $index) {
						<div class="mod_formcheckbox"
							 [ngClass]="{'error' : requirementHasError(i)}">
							<input type="checkbox"
								   formControlName="requirement_{{i}}"
								   id="requirement_{{i}}"
								   name="requirement_{{i}}"/>
							<label for="requirement_{{i}}" [innerHTML]="r.text">
							</label>
						</div>
						<app-input-error [control]="getRequirementControl(i)"></app-input-error>
					}
					<div class="navigation-buttons margin-top-40">
						<div>
							<input type="button"
								   (click)="switchBack(2)"
								   class="mod_button var_secondary"
								   value="Zurück">
						</div>
						<div>
							@if (!readonly) {
								<input
										type="button"
										(click)="finalize()"
										class="mod_button"
										value="Absenden">
							}
						</div>
					</div>
				</ng-container>
			}
			@if (steps == 4) {
				@if (hasBeiblatt()) {
					<p>
						{{tenant.content.angebot.beiblattSubmitText}}
					</p>
					<p>
						<button id="bestaetigungsButton" (click)="downloadBeiblatt(id)">Bestätigung herunterladen
						</button>
					</p>
					<p>
						{{tenant.content.angebot.beiblattDeadlineText}}
					</p>
					<p>
						Wir werden Ihre Eingabe zeitnah prüfen und Ihnen eine Rückmeldung geben.
					</p>
					<a routerLink="/">Zur Startseite</a>
				} @else {
					<p>Vielen Dank für die Eingabe Ihrer Offerte. Wir werden diese zeitnah prüfen und Ihnen eine
						Rückmeldung zu
						Ihrem Angebot geben.</p>
					<a routerLink="/">Zur Startseite</a>
				}
			}
		</form>
	</div>

</div>



